import * as Types from '../../../../../cassandra/src/types/types.mobile.generated'

import {TypedDocumentNode as DocumentNode} from '@graphql-typed-document-node/core'
export type AcceptNotMilitaryMutationVariables = Types.Exact<{[key: string]: never}>

export type AcceptNotMilitaryMutation = {
  __typename?: 'Mutation'
  loanApplicationUpdateRequirements: {
    __typename: 'LoanApplicationUpdateRequirementsResponse'
    success: boolean
  }
}

export const AcceptNotMilitaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: {kind: 'Name', value: 'AcceptNotMilitary'},
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {kind: 'Name', value: 'loanApplicationUpdateRequirements'},
            arguments: [
              {
                kind: 'Argument',
                name: {kind: 'Name', value: 'input'},
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {kind: 'Name', value: 'acceptNotMilitary'},
                      value: {kind: 'BooleanValue', value: true},
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                {kind: 'Field', name: {kind: 'Name', value: 'success'}},
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptNotMilitaryMutation, AcceptNotMilitaryMutationVariables>
